export default __webpack_public_path__ + "static/media/maschinenbaupalm-logo.9c3ad2b1.jpg";